import { SxProps, Theme } from '@mui/material';

export const newTemplateMainStyles: SxProps<Theme> = {
  display: 'flex',
  position: 'relative',
  height: '100%',
  '*::-webkit-scrollbar': {
    width: '6px',
  },
  '*::-webkit-scrollbar-track': {
    backgroundColor: 'customColors.gray.100',
  },
  '*::-webkit-scrollbar-thumb': {
    backgroundColor: 'customColors.gray.300',
  },
};

export const newTemplateContentStyles: SxProps<Theme> = {
  padding: '24px 32px',
  paddingBottom: '100px',
  flexGrow: '1',
  overflowY: 'auto',
};

export const sidebarStyles: SxProps<Theme> = {
  width: '400px',
  p: '24px',
  gap: '8px',
};

export const flexSpaceBetween: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const summaryErrorsStyles: SxProps = {
  position: 'absolute',
  top: '8px',
  left: '32px',
  right: '32px',
  width: 'max-content',
};

export const CreateNewTemplateUrl = '/create-new-template';
